import { useMutation } from '@tanstack/react-query'
import type { AxiosRequestConfig } from 'axios'
import { uploaderService } from '../uploader-service'

export const useFileUploadMutation = (config?: AxiosRequestConfig) =>
  useMutation({
    mutationFn: async (file: FormData) => {
      const resp = await uploaderService.uploadFile(file, config)
      return resp.data
    },
  })
